import { render, staticRenderFns } from "./ArticleCardSaveRow.vue?vue&type=template&id=68e0b33e&scoped=true"
import script from "./ArticleCardSaveRow.vue?vue&type=script&lang=js"
export * from "./ArticleCardSaveRow.vue?vue&type=script&lang=js"
import style0 from "./ArticleCardSaveRow.vue?vue&type=style&index=0&id=68e0b33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e0b33e",
  null
  
)

export default component.exports